export type FacebookError = {
    name: 'facebook-auth';
    type: 'not_authorized' | 'unknown';
    subtype?: never;
};

export type GoogleErrorType =
    | 'popup_closed_by_user'
    | 'access_denied'
    | 'immediate_failed'
    | 'idpiframe_initialization_failed';

type GoogleCustomErrorType = 'private-mode' | 'missing-token';

export type GoogleError = {
    name: 'google-auth';
    type: GoogleErrorType | GoogleCustomErrorType;
    subtype?: string;
};

export const googleOneTapErrorTypes = [
    'auto_cancel',
    'user_cancel',
    'tap_outside',
    'issuing_failed',
    'browser_not_supported',
    'invalid_client',
    'missing_client_id',
    'opt_out_or_no_session',
    'secure_http_required',
    'suppressed_by_user',
    'unregistered_origin',
    'unknown_reason'
] as const;

type GoogleOneTapCustomErrorType = 'missing-credential';

export type GoogleOneTapError = {
    name: 'google-onetap-auth';
    type: (typeof googleOneTapErrorTypes)[number] | GoogleOneTapCustomErrorType;
    subtype?: string;
};

type UserBackendServerErrorTypes =
    | 'register'
    | 'signin'
    | 'facebook'
    | 'google'
    | 'googleonetap';
type UserBackendServerErrorSubtypes = 'no_uuid' | 'not_logged_in';

export type UserBackendServerError = {
    name: 'user-error-auth';
    type: UserBackendServerErrorTypes;
    subtype: UserBackendServerErrorSubtypes;
};

export type NetworkError = {
    name: 'network-error-auth';
    type: UserBackendServerErrorTypes;
    subtype?: never;
};

type SupportedErrors =
    | FacebookError
    | GoogleError
    | GoogleOneTapError
    | UserBackendServerError
    | NetworkError;

export const formatErrorData = ({ name, type, subtype }: SupportedErrors) => {
    if (name === 'facebook-auth' || name === 'network-error-auth') {
        return { name, failure: 'true', type };
    }

    return {
        name,
        failure: 'true',
        type,
        subtype
    };
};
